module.exports = "<i aria-label=\"Tooltip\" class=\"fa fa-info-circle\" aria-hidden=\"false\" ng-click=\"vm.showTooltip(vm.text)\"></i> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-tooltip/dv-tooltip.html
// module id = L6K3
// module chunks = 0